module.exports = __webpack_public_path__ + "img/ico_hamburger_menu.a2ff1818.svg";